$(function () {

    if (navigator.appName == 'Microsoft Internet Explorer' || !!(navigator.userAgent.match(/Trident/) || navigator.userAgent.match(/rv:11/)) || (typeof $.browser !== "undefined" && $.browser.msie == 1)) {
        $('body').addClass('browser-is-ie');
    }

    $('.blogCategorySelector').on('change', function () {
        window.location = '/insights/blog?tag=' + this.value;
    });

    $(document).scroll(function(){
        var el = $('nav.desktop');
        var top = $(document).scrollTop();
        if (top > 80){
            $(el).addClass('scrolled');
        } else {
            $(el).removeClass('scrolled');
        }
    });

    // Action Form Label Animations - on click
    $('body').on('click', '.form-control', function () {
        $(this).siblings('.label-top').find('label.animate-label').addClass("animate");
    });
    // Action Form Label Animations - on focus
    $('body').on('focus', '.form-control', function () {
        $(this).siblings('.label-top').find('label.animate-label').addClass("animate");
    });
    // Action Form Label Animations - on blur
    $('body').on('blur', '.form-control', function () {
        if ($(this).val() == "") {
            $(this).siblings('.label-top').find('label.animate-label').removeClass("animate");
        }
    });


    // Form Label Animations - on focus
    $('.input-group input').focus(function () {
        $("label[for='" + $(this).attr('id') + "']").addClass("animate-label");
    });
    // Form Label Animations - on blur
    $('.input-group input').blur(function () {
        if ($(this).val() == "") {
            $("label[for='" + $(this).attr('id') + "']").removeClass("animate-label");
        }
    });
    
    // Add Hover class when detecting hover
    $('.js-hover li').click(function () {
        if ($(this).hasClass('active')) {
            $(this).parent().find('li').removeClass('active');
        }
        else {
            $(this).parent().find('li').removeClass('active');
            $(this).addClass('active');
        }
    });


    // Typed JS Extension
    if ($(".hero-banner").hasClass('js-typed')) {
        var typed = new Typed("#heading--typed", {
            stringsElement: '#heading--typed--strings',
            typeSpeed: 50,
            backSpeed: 50,
            backDelay: 1000,
            startDelay: 250,
            loop: true
        });
    }

    // Set background colors with transparency
    $('.portfolio-item').each(function () {

        var c;
        var ColorOutput = 'rgba(0,0,0,.9)';
        var hex = $(this).data('color');

        // Convert hex to rgba
        if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
            c = hex.substring(1).split('');
            if (c.length == 3) {
                c = [c[0], c[0], c[1], c[1], c[2], c[2]];
            }
            c = '0x' + c.join('');
            ColorOutput = 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ',.9)';
        }

        // Set background color
        $('.bg-color', this).css('background-color', ColorOutput);
        $('.bar', this).css('background-color', hex);
        $('.cta .btn', this).css('background-color', hex);
        $('.cta .btn', this).css('border-color', hex);
    });


    // Set brand colors
    var BrandColor = $('#brand-color').data('color');
    var TxtColor = tinycolor.mostReadable(BrandColor, ["#fff", "#000"]).toHexString();

    $('.js-brand--bg').css('background-color', BrandColor);
    $('.js-brand--bg-visible-text').css('color', TxtColor);


    // Grid Logo Details Toggle
    // On click identify item location and based on position and
    // browser size determine where to place information detail block.

    $('.js-toggle-grid-logos-detail').click(function () {
        // If clicked same item twice, close and end function
        if ($(this).hasClass('placement-active')) {

            $(this).closest('.grid-logos').find('.active').removeClass('active');
            $(this).closest('.grid-logos').find('.indicator').removeClass('indicator--top');
            $(this).closest('.grid-logos').find('.indicator').removeClass('indicator--right');
            $(this).closest('.grid-logos').find('.indicator').removeClass('indicator--bottom');
            $(this).closest('.grid-logos').find('.indicator').removeClass('indicator--left');

            $(this).closest('.grid-logos').find('.placement-active').removeClass('placement-active');
            return;
        }

        var ChildrenCount = $(this).closest('.grid-logos').find('li').length;
        var ChildPlacement = $(this).data('count');
        var BrowserSize = $(window).width();
        var SetPlacement = 0;
        var CarrotLocation = 'indicator--right';
        var OpenPlacement = 'left';


        // First item detected
        if (ChildPlacement == 1) {
            SetPlacement = 2;
            CarrotLocation = 'indicator--left';
            var OpenPlacement = 'right';

            if (BrowserSize <= '768') {
                CarrotLocation = 'indicator--top';
            }
        }
        // Last item detected
        if (ChildPlacement == ChildrenCount) {
            SetPlacement = ChildPlacement - 1;
            OpenPlacement = 'left';
            CarrotLocation = 'indicator--right';

            if (BrowserSize <= '768') {
                CarrotLocation = 'indicator--bottom';
            }
        }

        // If not first or last
        if (SetPlacement == 0) {

            // If desktop-view
            if (BrowserSize >= '768') {

                // On desktop-view items 4,7,10,13
                // need to be displayed to the right
                // as opposed to the standard left

                var IsLeftNode = false;
                if (ChildPlacement == 4) {
                    SetPlacement = ChildPlacement + 1;
                    CarrotLocation = 'indicator--left';
                    OpenPlacement = 'right';
                    IsLeftNode = true;
                }
                if (ChildPlacement == 7) {
                    SetPlacement = ChildPlacement + 1;
                    CarrotLocation = 'indicator--left';
                    OpenPlacement = 'right';
                    IsLeftNode = true;
                }
                if (ChildPlacement == 10) {
                    SetPlacement = ChildPlacement + 1;
                    CarrotLocation = 'indicator--left';
                    OpenPlacement = 'right';
                    IsLeftNode = true;
                }
                if (ChildPlacement == 13) {
                    SetPlacement = ChildPlacement + 1;
                    CarrotLocation = 'indicator--left';
                    OpenPlacement = 'right';
                    IsLeftNode = true;
                }

                if (IsLeftNode == false) {
                    SetPlacement = ChildPlacement - 1;
                    CarrotLocation = 'indicator--right';
                }

            }
            // If mobile-view
            else {
                SetPlacement = ChildPlacement + 1;
                CarrotLocation = 'indicator--bottom';
            }
        }


        // Remove and set new active node
        $(this).closest('.grid-logos').find('.active').removeClass('active');
        $(this).closest('.grid-logos').find('.indicator').removeClass('indicator--top');
        $(this).closest('.grid-logos').find('.indicator').removeClass('indicator--right');
        $(this).closest('.grid-logos').find('.indicator').removeClass('indicator--bottom');
        $(this).closest('.grid-logos').find('.indicator').removeClass('indicator--left');

        $(this).closest('.grid-logos').find('.placement-active').removeClass('placement-active');

        // Default - Open details
        if (OpenPlacement == 'left') {
            $(this).parent().prev().find('.indicator').addClass(CarrotLocation);
            $(this).parent().prev().find('a').addClass('active');
            $(this).addClass('placement-active');

            // Get Display Content
            var ContentHeading = $('.heading', this).html();
            var ContentSummary = $('.summary', this).html();

            // Set Display Content
            $(this).parent().prev().find('.heading-display').html(ContentHeading);
            $(this).parent().prev().find('.summary-display').html(ContentSummary);
        }
        if (OpenPlacement == 'right') {
            $(this).parent().next().find('.indicator').addClass(CarrotLocation);
            $(this).parent().next().find('a').addClass('active');
            $(this).addClass('placement-active');

            // Get Display Content
            var ContentHeading = $('.heading', this).html();
            var ContentSummary = $('.summary', this).html();

            // Set Display Content
            $(this).parent().next().find('.heading-display').html(ContentHeading);
            $(this).parent().next().find('.summary-display').html(ContentSummary);
        }
    });


    // Smooth Scroll
    $('a[href*="#"]:not([href="#"])').click(function () {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            var target = $(this.hash == '##' ? '[id="#"]' : this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            if (target.length) {



                // IF PAGE HAS BREADCRUMBS ADJUST HEIGHT - 250px
                var OffsetHeight = target.offset().top;
                if ($(document).find('.affixed-nav').length) {
                    OffsetHeight = OffsetHeight - $('.affixed-nav').height();
                }
                $('html,body').animate({ scrollTop: (OffsetHeight) }, 500);
                return false;
            }
        }
    });

    // Initial Functions
    CheckMenuHeight();
    JsSetHeight();
    JsSetMinHeight();
    JsEqualHeight();
    JS2ColVarNodeHeight();
    JsDivisibleWidth();
    JsDivisibleServicesArrows();
    JsWorkResults();

    // Fire after images are fully loaded to ensure
    // propper formatting for images
    $('img').bind('load', function () {
        JsEqualHeight();
    });



    // On Resize Functions
    $(window).resize(function () {
        CheckMenuHeight();
        JsSetHeight();
        JsEqualHeight();
        JsSetMinHeight();
        JS2ColVarNodeHeight();
        JsDivisibleWidth();
        JsDivisibleServicesArrows();
        JsWorkResults();
    });

    // If .icg-menu-desktop is larger than set height - show mobile
    function CheckMenuHeight() {
        // Remove classes that hide desktop menu and show mobile toggle
        $('.icg-menu-desktop').removeClass('icg-menu-desktop--hidden');
        $('.mobile-toggle').removeClass('mobile-toggle--visible');
        // Check if menu is larger than set height - if true set to mobile
        if ($('.icg-menu-desktop').height() > 112) {
            $('.icg-menu-desktop').addClass('icg-menu-desktop--hidden');
            $('.mobile-toggle').addClass('mobile-toggle--visible');
        }
    }


    // Set height
    function JsSetHeight() {
        $('.js-set-height').each(function () {
            $(this).attr({ style: "" });
            $(this).children().attr({ style: "" });

            var CurrentHeight = $(this).height();
            var MinHeight = $(this).data('heightmin');

            if (MinHeight > CurrentHeight) {
                $(this).css('height', MinHeight + 'px');
                $('.banner__container', this).css('height', '100%');
            }
            else if (MinHeight < CurrentHeight) {
                //$(this).children().css('padding', '60px 0px');
            }
        });
    }


    // Set min-height
    function JsSetMinHeight() {
        $('.js-set-min-height').each(function () {

            // First check if there are --children in node.
            // If there are no children set parent element height to min-height
            // otherwise set children hieght to min-height

            var ChildrenCount = $('.js-set-min-height--child', this).length;

            if (ChildrenCount == 0) {
                $(this).css('min-height', MinHeight + 'px');
            } else {
                var MinHeight = $(this).data('minheight');
                $('.js-set-min-height--child', this).css('min-height', MinHeight + 'px');
            }
        });
    }


    // Equal height children
    function JsEqualHeight() {
        $('.js-equal-height').each(function () {
            $('.js-equal-height--child', this).css('height', '');
            var LoopHeightCheck = 0;
            $('.js-equal-height--child', this).each(function () {
                if (LoopHeightCheck < $(this).height()) {
                    LoopHeightCheck = $(this).height();
                }
            });
            $('.js-equal-height--child', this).css('height', LoopHeightCheck + 'px');
        });
    }


    // Calculate item height for 2 column items with variable item nodes
    function JS2ColVarNodeHeight() {
        $('.js-varnodeheight').each(function () {
            var ElementHeight = $(this).height();
            var ChildrenCount = $('.js-varnodeheight--child', this).length;
            var DivisibleChildren = ChildrenCount / 2;
            var DivisibleHeight = ElementHeight / DivisibleChildren;
            $('.js-varnodeheight--child', this).css('height', DivisibleHeight + 'px');

        });
    }


    // Have items take up equal width of container
    function JsDivisibleWidth() {
        $('.js-divisible-width').each(function () {
            var ElementWidth = $(this).width();
            var ChildrenCount = $('.js-divisible-width--child', this).length;
            var DivisibleWidth = ElementWidth / ChildrenCount;
            $('.js-divisible-width--child', this).css('width', DivisibleWidth + 'px');
        });
    }


    // Have items take up equal width of container
    function JsDivisibleServicesArrows() {
        $('.services-arrows').each(function () {

            var ChildrenCount = $('.item', this).length;
            var ModifiedCount = ChildrenCount - 1;

            var ArrowWidth = ModifiedCount * 10;
            var AvailableContentWidth = 100 - ArrowWidth;

            var CalcBaseChildrenWidth = AvailableContentWidth / ChildrenCount;
            var CalcExtraChildrenWidth = CalcBaseChildrenWidth + 10;

            $('.item', this).css('width', CalcExtraChildrenWidth + '%');
            $('.item', this).last().css('width', CalcBaseChildrenWidth + '%');

            // Set arrow indicators position between blocks
            $('.services-arrows .item').each(function () {
                var ElementWidth = $(this).width();
                var ContentWidth = $('.item--centered', this).width();
                var ArrowWidth = $('.item--arrow', this).width();
                ArrowWidth = ArrowWidth / 2;

                var ArrowOffset = ElementWidth - ContentWidth;
                ArrowOffset = ArrowOffset - ArrowWidth;
                ArrowOffset = ArrowOffset / 2;

                $('.item--arrow', this).css('right', ArrowOffset + 'px');
            });

        });
    }


    // Work Results item heights
    function JsWorkResults() {
        $('.work-results').each(function () {
            $('.work-results--stats .item', this).css('height', "");
            $('.work-results--stats .item', this).css('max-width', "");

            var ElementHeight = $(this).height();
            var ContainerWidth = $('.work-results--stats', this).width();
            var ItemHeight = ElementHeight / 2;
            var ItemMaxWidth = ContainerWidth / 3;
            var BodyWidth = $('body').width();

            if (BodyWidth < 769) {
                ItemHeight = 150;
            }

            $('.work-results--stats .item', this).css('height', ItemHeight + "px");
            $('.work-results--stats .item .d-table-cell align-middle', this).css('max-width', ItemMaxWidth + "px");
        });
    }



    // Particles.JS
    particlesJS("particles-js", {
        "particles": {
            "number": {
                "value": 80,
                "density": {
                    "enable": true,
                    "value_area": 800
                }
            },
            "color": {
                "value": "#ffffff"
            },
            "shape": {
                "type": "circle",
                "stroke": {
                    "width": 0,
                    "color": "#000000"
                },
                "polygon": {
                    "nb_sides": 5
                },
                "image": {
                    "src": "/images/github.svg",
                    "width": 100,
                    "height": 100
                }
            },
            "opacity": {
                "value": 0.5,
                "random": false,
                "anim": {
                    "enable": false,
                    "speed": 1,
                    "opacity_min": 0.1,
                    "sync": false
                }
            },
            "size": {
                "value": 3,
                "random": true,
                "anim": {
                    "enable": false,
                    "speed": 40,
                    "size_min": 0.1,
                    "sync": false
                }
            },
            "line_linked": {
                "enable": true,
                "distance": 150,
                "color": "#ffffff",
                "opacity": 0.4,
                "width": 1
            },
            "move": {
                "enable": true,
                "speed": 1,
                "direction": "none",
                "random": false,
                "straight": false,
                "out_mode": "out",
                "bounce": false,
                "attract": {
                    "enable": false,
                    "rotateX": 600,
                    "rotateY": 1200
                }
            }
        },
        "interactivity": {
            "detect_on": "canvas",
            "events": {
                "onhover": {
                    "enable": false,
                    "mode": "repulse"
                },
                "onclick": {
                    "enable": false,
                    "mode": "push"
                },
                "resize": true
            },
            "modes": {
                "grab": {
                    "distance": 400,
                    "line_linked": {
                        "opacity": 1
                    }
                },
                "bubble": {
                    "distance": 400,
                    "size": 40,
                    "duration": 2,
                    "opacity": 8,
                    "speed": 3
                },
                "repulse": {
                    "distance": 200,
                    "duration": 0.4
                },
                "push": {
                    "particles_nb": 4
                },
                "remove": {
                    "particles_nb": 2
                }
            }
        },
        "retina_detect": true
    });
    particlesJS("particles-js-foot", {
        "particles": {
            "number": {
                "value": 80,
                "density": {
                    "enable": true,
                    "value_area": 800
                }
            },
            "color": {
                "value": "#ffffff"
            },
            "shape": {
                "type": "circle",
                "stroke": {
                    "width": 0,
                    "color": "#000000"
                },
                "polygon": {
                    "nb_sides": 5
                },
                "image": {
                    "src": "/images/github.svg",
                    "width": 100,
                    "height": 100
                }
            },
            "opacity": {
                "value": 0.5,
                "random": false,
                "anim": {
                    "enable": false,
                    "speed": 1,
                    "opacity_min": 0.1,
                    "sync": false
                }
            },
            "size": {
                "value": 3,
                "random": true,
                "anim": {
                    "enable": false,
                    "speed": 40,
                    "size_min": 0.1,
                    "sync": false
                }
            },
            "line_linked": {
                "enable": true,
                "distance": 150,
                "color": "#ffffff",
                "opacity": 0.4,
                "width": 1
            },
            "move": {
                "enable": true,
                "speed": 1,
                "direction": "none",
                "random": false,
                "straight": false,
                "out_mode": "out",
                "bounce": false,
                "attract": {
                    "enable": false,
                    "rotateX": 600,
                    "rotateY": 1200
                }
            }
        },
        "interactivity": {
            "detect_on": "canvas",
            "events": {
                "onhover": {
                    "enable": false,
                    "mode": "repulse"
                },
                "onclick": {
                    "enable": false,
                    "mode": "push"
                },
                "resize": true
            },
            "modes": {
                "grab": {
                    "distance": 400,
                    "line_linked": {
                        "opacity": 1
                    }
                },
                "bubble": {
                    "distance": 400,
                    "size": 40,
                    "duration": 2,
                    "opacity": 8,
                    "speed": 3
                },
                "repulse": {
                    "distance": 200,
                    "duration": 0.4
                },
                "push": {
                    "particles_nb": 4
                },
                "remove": {
                    "particles_nb": 2
                }
            }
        },
        "retina_detect": true
    });
});